import { saveAs } from "file-saver"

export const downloadDocument = async (document) => {
    if (document?.file) {
        const response = await fetch(document.file)
        const blob = await response.blob()
        saveAs(blob, document.filename)
    }
}